import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { BannerAction } from "../components/BannerAction";
export var BannerDismissButtonStyled = styled(BannerAction)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 32px;\n"])));
//# sourceMappingURL=BannerDismissButtonStyled.js.map